import React from "react";
import ReactDOM from "react-dom";
import Dropdown from "./Dropdown";


/**
 * Edit-in-place behavior for form components
 * @module CompoundItemListEditor
 * @param {Object} props React props
 */
export default class CompoundItemListEditor extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            listItemConfig: {}
        };
        this.clickOutsideHandler = this.handleClickOutside.bind(this);
    }

    /**
     * Get reference to context menu container itself
     * @returns {jQuery}
     */
    getDomSelf() {
        return $(ReactDOM.findDOMNode(this));
    }

    /**
     * React Component lifecycle method
     * https://reactjs.org/docs/react-component.html#componentdidmount
     */
    componentDidMount(){
        document.addEventListener('mousedown', this.clickOutsideHandler);
    }

    /**
     * React Component lifecycle method
     * https://reactjs.org/docs/react-component.html#componentwillunmount
     */
    componentWillUnmount(){
        document.removeEventListener('mousedown', this.clickOutsideHandler);
    }

    /**
     * Set the React reference of itself
     * @param {Object} node React node reference
     */
    setWrapperRef(node) {
        this.wrapperRef = node;
    }
    
    /**
     * Hide itself if mouse click outside the boundary
     * @param {Object} event React event
     */
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.props.context.onEditComplete();
        }
    }

    render(){

        return(
            <div 
                style={{'position': 'absolute', 'top': this.props.top, 'left': this.props.left, 'width' : this.props.width}}
                ref={this.setWrapperRef.bind(this)}
            >
                <Dropdown wide={false} 
                    options={this.props.options}
                    context={this.props.context} 
                    valKey={this.props.optionType}
                    selection={this.props.optionType==="fromIntent2"?this.props.selection1:this.props.selection2}
                    optionName={window.l.library.intents}
                    notifyAfterClose={true} />                    
            </div>
        );

    }

}
